module.exports = __webpack_public_path__ + "static/media/lang12.fd9e4403.mp3";